import { render, staticRenderFns } from "./AppointmentBlock.vue?vue&type=template&id=6a475bbd&"
import script from "./AppointmentBlock.vue?vue&type=script&lang=js&"
export * from "./AppointmentBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports